var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-copyright"},[_vm._v("© 2020 ООО «РУСЭНКАР»")])
}
var staticRenderFns = []

export { render, staticRenderFns }